<app-landingpage-header-child></app-landingpage-header-child>

<div class="container mt-4 mb-4 content-main">
    <style>
        p {
            font-size: 14px;
        }
    </style>
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{"rules_signature_anonymous.rules_contract_signature_anonymous" | translate}}<br>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div #focus tabindex="-1"
                style="height: calc(100vh - 14rem); overflow-y: scroll; border: 1px solid lightgrey;"
                class="my-3 px-3 py-3">
                <p style="line-height: 2;">
                    <strong>{{"rules_signature_anonymous.rules_contract_signature_anonymous_1" | translate}}</strong>
                    <br>
                    {{"rules_signature_anonymous.rules_contract_signature_anonymous_contents.modal_content_anonymous1_1" | translate}}
                    <br>
                    {{"rules_signature_anonymous.rules_contract_signature_anonymous_contents.modal_content_anonymous1_2" | translate}}
                </p>
                <p style="line-height: 2;">
                    <strong>{{"rules_signature_anonymous.rules_contract_signature_anonymous_2" | translate}}</strong>
                    <br>
                    {{"rules_signature_anonymous.rules_contract_signature_anonymous_contents.modal_content_anonymous2_1" | translate}}
                </p>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<app-landingpage-footer></app-landingpage-footer>